export default __webpack_public_path__ + "static/media/FileText.bf155bf8.svg";